import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Surname = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        {props.required ? 'Surname *' : 'Surname'}
      </Col>
      <Col sm={7}>
          <FormControl
            name="surname"
            type="text"
            value={props.surname}
            onChange={props.handleChangeSurname}
            required={props.required}
            disabled={props.disabled}
            autoComplete="off"
          />
      </Col>
    </FormGroup>
  )
}

Surname.propTypes = {
  surname: PropTypes.string,
  handleChangeSurname: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

Surname.defaultProps = {
  disabled: false,
  required: false
};

export default Surname;



// WEBPACK FOOTER //
// ./src/app/components/surname/Surname.js